import React from 'react';

import { UiKit } from 'components';

export default function StoreName({ name = '', uniqueName = '' }) {
  return (
    <UiKit.Flex gap={4}>
      {name && <UiKit.Text>{name}</UiKit.Text>}
      {uniqueName && <UiKit.Text variant={500}>({uniqueName})</UiKit.Text>}
    </UiKit.Flex>
  );
}
